module.exports = __webpack_public_path__ + "22_sdm.jpg?883e92ba02e623d79928b02ebace0a73";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/22_sdm.jpg
// module id = 188
// module chunks = 0